import React from "react";
import inhalerIcon from "../../Assets/Images/inhaler.svg";

export default function InhalerCard({ totalCount, filterBy }) {
  const suggestedInhaler = () => {
    if (filterBy === "hourly" || filterBy === "" || filterBy === "daily") {
      return 3;
    } else if (filterBy === "weekly") {
      return 21;
    }
  };
  return (
    <div className="dash-cards w-100 h-100 d-flex flex-column p-4">
      <div className="ms-2 my-auto">
        <p className="fs-24 fw-600 Roboto text-grey-black mb-3">
          Inhaler Summary
        </p>
        <p className="fs-20 fw-700 Roboto text-primry mb-3">
          <span className=" fw-500 text-secondary">Used </span>{" "}
          {totalCount > suggestedInhaler() ? (
            <span className="text-danger">{totalCount}</span>
          ) : (
            totalCount || 0
          )}{" "}
          <span className=" fw-500 text-secondary">Times</span>{" "}
        </p>
        <p className="fs-20 fw-700 Roboto text-primry mb-3">
          <span className=" fw-500 text-secondary">Recomended </span>{" "}
          {suggestedInhaler()}
          <span className="ms-2 fw-500 text-secondary">Times</span>{" "}
          <span className="ms-2 fw-500 text-secondary">
            {filterBy === "hourly" || filterBy === "" ? "Daily" : filterBy}
          </span>
        </p>
        <img
          src={inhalerIcon}
          alt="inhaler"
          width={80}
          height={80}
          className="my-3"
        />
        {/* <p className="fs-24 fw-600 Roboto mb-0 text-grey-black">
          Inhaler Extra
        </p> */}
        {/* <p className="fs-20 fw-700 Roboto text-danger">
          {totalCount - suggestedInhaler() < 0
            ? "0"
            : totalCount - suggestedInhaler() || 0}
        </p> */}
      </div>
    </div>
  );
}
